/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Chip, Grid, Icon, IconButton, useTheme } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import MDBox from 'shared/components/MDBox';
import MDTypography from 'shared/components/MDTypography';
import DashboardLayout from 'shared/examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'shared/examples/Navbars/DashboardNavbar';
import DataTableApi from 'shared/components/tables/DatatableApi';

import MDInput from 'shared/components/MDInput';
import { useEffect, useState } from 'react';
import MDButton from 'shared/components/MDButton';
import NotificationItem from 'shared/examples/Items/NotificationItem';
import CriterionService from 'shared/services/criterion/criterion.service';
import PopUp, { dialogButton } from 'shared/components/pop_up';
import { useNavigate } from 'react-router-dom';
import { translateRoleNumberToString } from 'utils/essentialData';
import MDProgress from 'shared/components/MDProgress';
import toastError from 'shared/components/snackbar/error/toastError';
import toastSuccess from 'shared/components/snackbar/success/toastSuccess';

function EvaluationCriteria() {
  const { palette } = useTheme();
  const { ternary, quartenary, quintenary, sextenary, white } = palette;

  const navigate = useNavigate();
  const [openPopUp, setOpenPopUp] = useState(false);
  const [criterionStatus, setCriterionStatus] = useState();
  const [dataTable, setDataTable] = useState([]);
  const [rowSelected, setRowSelected] = useState();
  const [filter, setFilter] = useState('');
  const [filterSearch, setFilterSearch] = useState('');

  const [loadingData, setLoadingData] = useState(false);
  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);

  const handleChips = (value) => {
    const role = value;
    let color = ternary.main;
    if (role === 99) color = quartenary.main;
    if (role === 1) color = quintenary.main;
    if (role === 2) color = sextenary.main;
    return (
      <Chip
        label={translateRoleNumberToString(role).toUpperCase()}
        style={{ backgroundColor: color, color: white.main, width: '100%' }}
      />
    );
  };

  const dataTableData = {
    columns: [
      {
        Header: 'Critério',
        accessor: 'name',
      },
      {
        Header: 'Perfil associado',
        accessor: 'role',
        Cell: ({ value }) => handleChips(value),
        width: '25%',
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) => (value === 1 ? 'Ativo' : 'Inativo'),
        width: '25%',
      },
      {
        Header: 'ações',
        accessor: 'action',
        width: '15%',
      },
    ],

    rows: dataTable?.data || [],
  };

  const handleCancelDelete = () => setOpenPopUp(false);

  const handleApplyDelete = async () => {
    try {
      let criterionStatus = rowSelected.original.status;
      if (criterionStatus === 1) criterionStatus = 0;
      else criterionStatus = 1;

      const data = {
        uuid: rowSelected.original.uuid,
        status: criterionStatus,
      };
      await CriterionService.updateStatus(data);
      toastSuccess('Critério da avaliação editado com sucesso');
      loadCriteria(tablePage, tableLimit, filterSearch);
    } catch (e) {
      if (e.message.includes('<p>')) {
        toastError(<div dangerouslySetInnerHTML={{ __html: e.message }} />);
      } else toastError(e.message);
    } finally {
      setOpenPopUp(false);
    }
  };

  const loadCriteria = async (page = 1, limit = 5, filter = '') => {
    try {
      setLoadingData(true);
      const filterValue = filter !== '' ? `&filter=${filter.trim()}` : '';
      const res = await CriterionService.list(
        `?page=${page}&limit=${limit}${filterValue}`
      );
      if (res) {
        setDataTable(res);
        setTableTotal(res?.meta?.total);
      }
    } catch (e) {
      toastError(e.message);
    } finally {
      setLoadingData(false);
    }
  };

  const handleChange = (event) => {
    const { value } = event.target;
    if (value === '') {
      loadCriteria(1, tableLimit);
      setTablePage(1);
      setFilterSearch('');
    }
    setFilter(value);
  };

  const handleClickSearch = () => {
    setFilterSearch(filter.trim());
    setTablePage(1);
    loadCriteria(1, tableLimit, filter);
  };

  useEffect(
    () => loadCriteria(tablePage, tableLimit, filterSearch),
    [tablePage, tableLimit]
  );

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pb={3}>
          <MDBox mb={3}>
            <MDBox pb={1}>
              <Card>
                <MDBox p={3} lineHeight={1}>
                  <MDTypography variant='h5' fontWeight='medium'>
                    Filtros
                  </MDTypography>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <MDInput
                        type='text'
                        name='filter'
                        value={filter}
                        size='small'
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              sx={{ visibility: filter ? 'visible' : 'hidden' }}
                              size='small'
                              onClick={() =>
                                handleChange({ target: { value: '' } })
                              }
                            >
                              <ClearIcon />
                            </IconButton>
                          ),
                        }}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={2} display='flex'>
                      <MDButton
                        disabled={!filter}
                        variant='gradient'
                        color='primary'
                        size='small'
                        fullWidth
                        onClick={handleClickSearch}
                      >
                        BUSCAR
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </MDBox>
            <Card>
              <MDBox p={3} lineHeight={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <MDTypography variant='h5' fontWeight='medium'>
                      Critérios da avaliação
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MDBox width='12rem' ml='auto'>
                      <MDButton
                        variant='gradient'
                        color='primary'
                        size='small'
                        fullWidth
                        onClick={() => navigate('/criterios/criar')}
                      >
                        CRIAR
                      </MDButton>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              {loadingData && !dataTable?.data ? (
                <MDProgress
                  variant='gradient'
                  variantProgress='indeterminate'
                  color='primary'
                />
              ) : (
                <DataTableApi
                  table={dataTableData}
                  onRowSelected={setRowSelected}
                  entriesPerPage={{ defaultValue: tableLimit }}
                  setTableLimit={setTableLimit}
                  tableLimit={tableLimit}
                  setTablePage={setTablePage}
                  tablePage={tablePage}
                  tableTotal={tableTotal}
                  loading={loadingData}
                >
                  {[
                    <NotificationItem
                      onClick={() => {
                        const { uuid } = rowSelected.original;
                        navigate('/criterios/editar/' + uuid);
                      }}
                      icon={<Icon>create</Icon>}
                      title='Editar'
                      key='option_edit'
                    />,
                    <NotificationItem
                      onClick={() => {
                        const { status } = rowSelected.original;
                        setOpenPopUp(true);
                        setCriterionStatus(status);
                      }}
                      icon={<Icon>create</Icon>}
                      title='Alterar status'
                      key='option_delete'
                    />,
                  ]}
                </DataTableApi>
              )}
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <PopUp
        open={openPopUp}
        onClose={() => setRowSelected()}
        title='Alterar status'
        contentText={`Deseja ${
          criterionStatus === 1 ? 'inativar' : 'ativar'
        } o critério de avaliação?`}
        actions={[
          <MDButton
            color='dark'
            variant='outlined'
            onClick={handleCancelDelete}
            style={dialogButton}
            key='cancel'
          >
            cancelar
          </MDButton>,
          <MDButton
            color='primary'
            onClick={handleApplyDelete}
            style={dialogButton}
            key='confirm'
          >
            confirmar
          </MDButton>,
        ]}
      />
    </>
  );
}

export default EvaluationCriteria;
